import { Outlet } from 'react-router-dom'

import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import NewFormEditor from 'modules/forms/components/newFormEditor'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function TemplateQuestionsPage() {
  const { id } = useStrictParams<'id'>()

  return (
    <ResponsivePage.Body variant="fullscreen">
      <NewFormEditor id={id} resourceType="Surveys::Survey" />
      <Outlet />
    </ResponsivePage.Body>
  )
}
